{
  "cms.richText.action.blockquote": "Quote",
  "cms.richText.action.bold": "Bold",
  "cms.richText.action.bulletList": "Bullet list",
  "cms.richText.action.clearFormat": "Clear formatting",
  "cms.richText.action.color": "Text colour",
  "cms.richText.action.heading1": "Heading 1",
  "cms.richText.action.heading2": "Heading 2",
  "cms.richText.action.heading3": "Heading 3",
  "cms.richText.action.image": "Insert image",
  "cms.richText.action.italic": "Italic",
  "cms.richText.action.link": "Insert link",
  "cms.richText.action.orderedList": "Numbered list",
  "cms.richText.action.redo": "Redo",
  "cms.richText.action.underline": "Underline",
  "cms.richText.action.undo": "Undo",
  "cms.richText.action.video": "Insert video",
  "cms.richText.color.black": "Black",
  "cms.richText.color.deepTeal": "Deep teal",
  "cms.richText.color.green": "Green",
  "cms.richText.color.lightGreen": "Light green",
  "cms.richText.color.menu": "Colour menu",
  "cms.richText.color.remove": "Remove colour",
  "cms.richText.color.teal": "Teal",
  "cms.richText.dialog.cancel": "Cancel",
  "cms.richText.dialog.image.title": "Insert image",
  "cms.richText.dialog.image.urlLabel": "Image URL",
  "cms.richText.dialog.insert": "Insert",
  "cms.richText.dialog.link.title": "Insert link",
  "cms.richText.dialog.link.urlLabel": "URL",
  "cms.richText.dialog.upload": "Upload from your device",
  "cms.richText.dialog.video.title": "Insert video",
  "cms.richText.dialog.video.urlLabel": "Video URL",
  "cms.richText.loading": "Loading editor…",
  "cms.richText.placeholder": "Start writing…",
  "cms.richText.toolbar.label": "Formatting toolbar"
}
